import Google from 'src/components/Icons/Google';
import ConnectWalletModalButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalButton';
import usePrivyGoogleOAuth from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalPrivyOptions/hooks/usePrivyGoogleOAuth';

export default function PrivyGoogleOAuthButton() {
	const { loginWithGoogleOAuth, isGoogleOAuthLoginInProgress } =
		usePrivyGoogleOAuth();

	return (
		<ConnectWalletModalButton
			onClick={loginWithGoogleOAuth}
			leftIcon={Google}
			isLoading={isGoogleOAuthLoginInProgress}
		>
			Google
		</ConnectWalletModalButton>
	);
}
